<template>
    <Header></Header>
    <div class="breadcrumbs">
        <Breadcrumbs />
    </div>
    <div class="spacer-1"></div>
    <div class="head">
        <div class="title">
            <h1>{{ $t('credits_title') }}</h1>
            <br>
            <br>
        </div>
    </div>
    <div id="credits">
        <ul>
            <li>
                <a class="credit" href="http://www.freepik.com">Map-Marker designed by Freepik</a>
            </li>
            <li>
                <a class="credit" data-cy="credit"
                    href="https://de.freepik.com/fotos-kostenlos/luftaufnahme-eines-geschaeftsteams_17117573.htm#query=Holding&position=0&from_view=search&track=sph&uuid=a87ac766-4659-4500-8db5-04a34f718cae"
                    target="_blank">Image
                    by rawpixel.com on Freepik</a>
            </li>
            <li>
                <a class="credit" data-cy="credit"
                    href="https://de.freepik.com/fotos-kostenlos/geschaeftselementzusammensetzung-mit-smartphone_3354930.htm#query=Bereich%20Personal%20und%20Buchhaltung&position=4&from_view=search&track=ais&uuid=d4567cfd-a5cb-4216-acbc-d837b08c82f1"
                    target="_blank">
                    Image by Freepik</a>
            </li>
            <li>
                <a class="credit" data-cy="credit"
                    href="https://de.freepik.com/fotos-kostenlos/vogelperspektive-von-den-verschiedenen-geschaeftsleuten-die-zusammen-sich-treffen-haben_2792061.htm#query=Verwaltungsrat&position=3&from_view=search&track=ais&uuid=5dcdaf10-5e4c-4017-b086-478547cd0e07"
                    target="_blank">Image
                    by rawpixel.com on Freepik</a>
            </li>
            <li>
                <a class="credit" data-cy="credit"
                    href="https://de.freepik.com/fotos-kostenlos/gruene-blattbeschaffenheit-blattbeschaffenheitshintergrund_26542540.htm#query=bl%C3%A4tter&position=7&from_view=search&track=sph&uuid=abc93ac5-346b-444c-a0d8-d711ac973fa1">Bild
                    von boyarkinamarina auf Freepik</a>
            </li>
            <li>
                <p>
                    Copyright (c) 2023 by Saleh Riaz Qureshi (https://codepen.io/salehriaz/pen/erJrZM)
                </p>
                <p>
                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                    associated
                    documentation files (the "Software"), to deal in the Software without restriction, including without
                    limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
                    of
                    the Software, and to permit persons to whom the Software is furnished to do so, subject to the following
                    conditions:
                </p>
                <p>
                    The above copyright notice and this permission notice shall be included in all copies or substantial
                    portions of the Software.
                </p>
                <p>
                    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
                    LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                    NO
                    EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                    WHETHER IN
                    AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                    USE
                    OR OTHER DEALINGS IN THE SOFTWARE.
                </p>
            </li>
            <li>
                <p>
                    Copyright (c) 2023 by Álvaro (https://codepen.io/alvarotrigo/pen/PoOXJpM)
                    Fork of an original work Day and Night Toggle Button (https://codepen.io/_Raunaq_/pen/wbRwea)
                </p>
                <p>
                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
                    associated
                    documentation files (the "Software"), to deal in the Software without restriction, including without
                    limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
                    of
                    the Software, and to permit persons to whom the Software is furnished to do so, subject to the following
                    conditions:
                </p>
                <p>
                    The above copyright notice and this permission notice shall be included in all copies or substantial
                    portions of the Software.
                </p>
                <p>
                    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT
                    LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                    NO
                    EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
                    WHETHER IN
                    AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                    USE
                    OR OTHER DEALINGS IN THE SOFTWARE.
                </p>
            </li>
        </ul>
    </div>
    <Footer></Footer>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import Breadcrumbs from '../components/Breadcrumbs.vue'

export default {
    name: 'CreditsView',
    components: {
        Header, Footer, Breadcrumbs
    },
}
</script>

<style scoped>
.breadcrumbs {
    margin-left: 8vw;
    margin-right: 8vw;
    margin-top: 5vh;
}

.head {
    margin-left: 10vw;
    margin-right: 10vw;
}

#credits {
    padding: 20px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    margin-left: 10vw;
    margin-right: 10vw;
    justify-content: flex-end;
}

#credits>ul>li {
    color: gray;
    list-style: disc;
    overflow-wrap: break-word;
}

#credits>ul>li>a,
#credits>ul>li>p {
    font-family: "indivisible-variable", sans-serif;
    font-variation-settings: "wght" 400;
    font-size: 14pt;
    text-decoration: none;
    color: gray;
}

@media only screen and (max-width: 1050px) {
    .breadcrumbs {
        margin-top: 18vh
    }
}</style>